// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import { getAPIConfig, cropImageUrl } from '@tcp/core/src/utils';

export const flattenSet = (set) => {
  const flatSet = {};
  if (set && Array.isArray(set)) {
    const setLength = set.length;
    for (let i = 0; i < setLength; i += 1) {
      flatSet[set[i].key] = set[i].val;
    }
  }
  return flatSet;
};

export const handleNavigationDrawer =
  (openNavigationDrawer, closeNavigationDrawer, isOpen) => () => {
    return isOpen ? closeNavigationDrawer('l1_drawer') : openNavigationDrawer('l1_drawer');
  };

export const filterAndUpdateData = (data, brandID) => {
  const validClasses = ['header__brand-tab--tcp', 'header__brand-tab-gymboree'];
  const filteredData = data.filter((item) => validClasses.includes(item.class));
  const classMapping = {
    tcp: `header__brand-tab--tcp`,
    gymboree: `header__brand-tab-gymboree`,
  };

  const targetClass = classMapping[brandID] ?? null;
  const updatedData = filteredData.map(({ class: itemClass, ...rest }) => ({
    ...rest,
    class: itemClass,
    active: itemClass === targetClass,
  }));

  return updatedData.sort((a, b) => b.active - a.active);
};

export const getMiddleNavStyle = () => {
  if (typeof window !== 'undefined') {
    const middleNavElement = document.getElementsByClassName('middle-nav-section')[0];

    if (middleNavElement) {
      const middleNavHeight =
        middleNavElement.getBoundingClientRect()?.height +
        middleNavElement.getBoundingClientRect()?.y;

      if (middleNavHeight) {
        return middleNavHeight - 2;
      }
    }
  }
  return 157;
};

export const filterBrandTabs = (brandTabs) => {
  const { reqHostname } = getAPIConfig();
  const domain = reqHostname?.split('.')[1];
  // Helper function to check if section is an array and return the 0th element if valid
  const getFirstArrayElement = (section) =>
    Array.isArray(section) && section.length > 0 ? section[0] : section;

  // Function to transform each tab
  const transformTab = (tab) => ({
    ...tab,
    stickyTabSection: getFirstArrayElement(tab.stickyTabSection),
    brandTabSection: getFirstArrayElement(tab.brandTabSection),
    brandThemeSection: getFirstArrayElement(tab.brandThemeSection),
    headerBackground: getFirstArrayElement(tab.headerBackground),
  });
  // Function to filter tabs based on domain
  const filterTab = (tab) => {
    const tabDomain = tab.url.split('.')[1];
    return (
      tabDomain !== 'pjplace' &&
      tabDomain !== 'sugarandjade' &&
      !tab.class.includes('snj') &&
      !tab.class.includes('pjp')
    );
  };
  // Apply transformation and filtering based on domain
  return brandTabs
    ?.map(transformTab)
    ?.filter(domain === 'childrensplace' || domain === 'gymboree' ? filterTab : Boolean);
};

export const getBackgroundImage = (imageVal) => {
  const { url, url_t: urlT = '', url_m: urlM = '' } = imageVal;
  const desktopUrl = cropImageUrl(url);
  const tabletUrl = !isEmpty(urlT) ? cropImageUrl(urlT) : desktopUrl;
  const mobileUrl = !isEmpty(urlM) ? cropImageUrl(urlM) : desktopUrl;

  return {
    desktopSrc: desktopUrl,
    tabletSrc: tabletUrl,
    mobileSrc: mobileUrl,
  };
};
